<template>
  <div id="rede-credenciada-empty">
    <div class="content-empty">
      <div class="icon-circle">
        <svg-icone :icone="funcionalidade.parametros.dashboard.icone" :width="64" :height="64"
                   :cor="esquemaDeCor.aplicacao.corPrimariaAplicacao" />
      </div>
      <br>
      <h3>
        {{ title }}
      </h3>
      <p class="paragraph">
        {{ description }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'GuiaImpressoEmpty',
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'esquemaDeCor', 'frameId']),
    parametros () {
      return this.funcionalidade.parametros.textos
    }
  },
  data () {
    return {
      title: '',
      description: ''
    }
  },
  created () {
    this.title = this.parametros.tituloVazioGuiaImpresso
    this.description = this.parametros.textoVazioGuiaImpresso
  }
}
</script>

<style scoped lang="less">
#rede-credenciada-empty {
  .content-empty {
    display: flex;
    flex-direction: column;
    gap: 8px;
    place-items: center;
    padding-top: 150px;
    color: dimgrey;

    .icon-circle {
      background: var(--cor-primaria-aplicacao-transparent);
      border-radius: 100%;
      padding: 16px;
      line-height: 0;
    }

    .paragraph {
      max-width: 350px;
      text-align: center;
    }
  }
}

</style>
